module.exports = __webpack_public_path__ + "img/golf-flag-hole.494509ca.svg";